import styled from "styled-components";
import {ACTIVE} from "../../../../themes/css-global-classes";


export const FilterLinkDefaultBox =  styled.a`
    display: flex;
    padding:1rem;
    color: ${props => props.theme.colors.textMiddleDark};

    &:hover {
      color: ${props => props.theme.colors.textHover};
    }

  
  &.${ACTIVE}{
      color: ${props => props.theme.colors.brandPrimary};
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        flex-direction: column;
        font-size: 1.4rem;
        align-items: center;
        text-align: center;
        padding: 0;

        &.${ACTIVE}{
            color: ${props => props.theme.colors.textLight};
        }
    }

    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
      flex-direction: row;
      line-height: 2rem;
      font-size: 1.3rem;
      font-weight: 600;
      text-transform: uppercase;

      ::after{
        content: "";
        background: ${props => props.theme.colors.boxBorderContrast};
        height: 20px;
        width: 1px;
        margin-left: 4rem;
        margin-right: 1rem;
      }
    }
`;
